<kal-tab-group [formControl]="tabControl">

    <kal-tab *ngFor="let tab of displayedViewerDocumentsList; index as i">

        <ng-template kalTabLabel>
            <div class="kal-tab-header__label">{{ tab.label }}</div>
            <kal-icon (click)="closeTab(i)">close</kal-icon>
        </ng-template>

        <ng-template kalTabContent>
            <app-viewer-document [report]="tab.report"
                                 (closeViewer)="closeTab(i)"
                                 [filename]="tab.fileName"></app-viewer-document>
        </ng-template>

    </kal-tab>

</kal-tab-group>
